import { createSelector } from "reselect";
import getLocationMetadata from "../base_getters/get_location_metadata";

const getIsClientUserPage = createSelector([
  getLocationMetadata
], (locationMetadata) => {
  return locationMetadata.isClientUserPage || false;
});

export default getIsClientUserPage;